import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

export const constantRoutes = [
  {
    path: "/",
    redirect:'/home'
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/pages/home.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/pages/about.vue"),
    meta: {
      hidden: true,
      title: "关于我们",
    },
  },
  {
    path: "/service",
    name: "service",
    component: () => import("@/views/pages/service.vue"),
    meta: {
      hidden: true,
      title: "一站式服务",
    },
  },
  {
    path: "/internetThings",
    name: "internetThings",
    component: () => import("@/views/pages/service_internetThings.vue"),
    meta: {
      hidden: true,
      title: "物联网接入",
    },
  },
  {
    path: "/remoteSensing",
    name: "remoteSensing",
    component: () => import("@/views/pages/service_remoteSensingServices.vue"),
    meta: {
      hidden: true,
      title: "遥感服务",
    },
  },
  {
    path: "/project",
    name: "project",
    component: () => import("@/views/pages/service_project.vue"),
    meta: {
      hidden: true,
      title: "项目管理",
    },
  },
  {
    path: "/case",
    name: "case",
    component: () => import("@/views/pages/case.vue"),
    meta: {
      title: "案例展示",
    },
  },
  {
    path: "/caseInfo",
    name: "caseInfo",
    component: () => import("@/views/pages/caseInfo.vue"),
    meta: {
      title: "案例",
    },
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("@/views/pages/contact.vue"),
    meta: {
      title: "联系我们",
    },
  },
  {
    path: "/403",
    name: "403",
    component: () => import("@/views/403.vue"),
    meta: {
      hidden: true,
    },
  },
];

export const asyncRoutes = [];

const routes: Array<RouteRecordRaw> = [];

const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes as RouteRecordRaw[],
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title}_陕西北斗环境信息产业有限公司` : "陕西北斗环境信息产业有限公司";
  next();
})

export default router;
